exports = module.exports = require("../../../../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-pages-retrospective-components-footer--footer-footer{background:#09090b;padding:5rem 0}.src-pages-retrospective-components-footer--footer-footerContent{max-width:1280px;margin:0 auto;padding:0 1.5rem;display:flex;justify-content:center;align-items:center}.src-pages-retrospective-components-footer--footer-footerLogoWrapper svg{width:60px}", ""]);

// exports
exports.locals = {
	"footer": "src-pages-retrospective-components-footer--footer-footer",
	"footerContent": "src-pages-retrospective-components-footer--footer-footerContent",
	"footerLogoWrapper": "src-pages-retrospective-components-footer--footer-footerLogoWrapper"
};